import { useEffect, useState } from 'react';

/**
 * Hook to manage feature announcement visibility based on localStorage
 * @param {string} featureId - Unique identifier for the feature
 * @param {boolean} enabled - Whether to enable this feature announcement (default: true)
 * @returns {object} - { hasSeenAnnouncement, markAsSeen, showAnnouncement }
 */
export function useFeatureAnnouncement(featureId, enabled = true) {
  const [hasSeenAnnouncement, setHasSeenAnnouncement] = useState(true); // Default to true to avoid flashing
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const storageKey = `feature_announcement_${featureId}`;

  useEffect(() => {
    // Check on client side only
    if (typeof window !== 'undefined' && enabled) {
      const seen = localStorage.getItem(storageKey) === 'true';
      setHasSeenAnnouncement(seen);
      // Show announcement if not seen
      if (!seen) {
        setShowAnnouncement(true);
      }
    }
  }, [storageKey, enabled]);

  const markAsSeen = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(storageKey, 'true');
      setHasSeenAnnouncement(true);
      setShowAnnouncement(false);
    }
  };

  return {
    hasSeenAnnouncement,
    markAsSeen,
    showAnnouncement,
    setShowAnnouncement,
  };
}
